var map = {
	"./de/bg.jpg": "iJRy",
	"./en/bg.jpg": "ifg+",
	"./es/bg.jpg": "4HeC",
	"./fr/bg.jpg": "0ZVc",
	"./ja/bg.jpg": "es4g",
	"./ko/bg.jpg": "0TKa",
	"./pt/bg.jpg": "O6OQ",
	"./ru/bg.jpg": "qSFg",
	"./tc/bg.jpg": "yvU4",
	"./th/bg.jpg": "mSuA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "T9HJ";